import classnames from "classnames";
import castArray from "lodash/castArray";
import React from "react";
import Image from "../image";
import * as styles from "./index.module.scss";

export default ({
  mediaType,
  mediaKey,
  imagePreview,
  sizes,
  height = "100%",
  classNames,
  split,
  children,
  noAnimation,
  style
}) =>
  mediaType && mediaKey ? (
    <div
      className={classnames(
        ...castArray(classNames),
        split
          ? styles.BackgroundImageWrapperSplit
          : styles.BackgroundImageWrapperFull,
      )}
      style={{ width: "100%", height, ...style}}
    >
      <Image
        noAnimation={noAnimation}
        className={classnames(styles.MobileBackgroundImage)}
        mediaType={mediaType}
        mediaKey={mediaKey}
        imagePreview={imagePreview}
        size={sizes}
        style={{ height: "100%", width: "100%"}}
      />
      {children}
    </div>
  ) : (
    <div
      className={classnames(
        ...castArray(classNames),
        split
          ? styles.BackgroundImageWrapperSplit
          : styles.BackgroundImageWrapperFull,
        styles.DefaultImage,
      )}
      style={{ width: "100%", height }}
    >
      {children}
    </div>
  );
